export const FilterValues = {
  equals: 'equals',
  greaterThan: 'greaterThan',
  lessThan: 'lessThan',
  inRange: 'inRange',
  greaterThanOrEqual: 'greaterThanOrEqual',
  lessThanOrEqual: 'lessThanOrEqual'
};

export const FilterColumnFields = {
  status: 'status',
  account: 'account',
  transactionType: 'transactionType',
  amount: 'amount',
  amountType: 'amountType',
  symbol: 'symbol',
  frequency: 'frequency',
  next: 'next',
  endDate: 'endDate',
  dayToExecute: 'dayToExecute'
};

export const AmountTypeValues = {
  dollars: 'Dollars',
  shares: 'Shares'
};

export const TransactionTypeValues = {
  Buy: 'Buy',
  Sell: 'Sell'
};

export const DurationValues = {
  runUntilStopped: 'Run until stopped',
  stopOnSelectedDate: 'Stop on selected date'
};

export const DaysToExecuteValues = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  '1st',
  '2nd',
  '3rd',
  '4th',
  '5th',
  '6th',
  '7th',
  '8th',
  '9th',
  '10th',
  '11th',
  '12th',
  '13th',
  '14th',
  '15th',
  '16th',
  '17th',
  '18th',
  '19th',
  '20th',
  '21st',
  '22nd',
  '23rd',
  '24th',
  '25th',
  '26th',
  '27th',
  '28th',
  '29th',
  '30th',
  '31st'
];

export const FrequencyValues = [
  'Weekly',
  'Every other week',
  'Twice a month',
  'Monthly',
  'Every 3 months',
  'Every 6 months',
  'Annually'
];

export const StatusValues = ['Active', 'Restarted', 'Stopped'];
